// extracted by mini-css-extract-plugin
module.exports = {"root":"Calendar_root__1ysqx","disabled":"Calendar_disabled__2clAy"};